export default "__VITE_ASSET___7AVYm8___"